import { render, staticRenderFns } from "./MatchTimelineChart.vue?vue&type=template&id=59af3b92&scoped=true"
import script from "./MatchTimelineChart.vue?vue&type=script&lang=js"
export * from "./MatchTimelineChart.vue?vue&type=script&lang=js"
import style0 from "./MatchTimelineChart.vue?vue&type=style&index=0&id=59af3b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af3b92",
  null
  
)

export default component.exports